"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PlotBand_1 = require("../PlotBand");
var PlotLine_1 = require("../PlotLine");
var utils_1 = require("../../../utils");
function default_1(base, xAxisElements, modifiers) {
    if (modifiers === void 0) { modifiers = {}; }
    var options = [];
    var _a = modifiers, onSetExtremes = _a.onSetExtremes, cleanedModifiers = __rest(_a, ["onSetExtremes"]);
    var dateTimeLabelFormats = base.dateTimeLabelFormats, chartType = base.chartType;
    var _b = dateTimeLabelFormats, millisecond = _b.millisecond, second = _b.second, minute = _b.minute, hour = _b.hour, day = _b.day, week = _b.week, month = _b.month, year = _b.year;
    var colors = utils_1.chartColors(base.colors);
    var afterSetExtremes = function (event) {
        var min = event.min, max = event.max, trigger = event.trigger;
        if (trigger === 'navigator') {
            onSetExtremes(min, max);
        }
    };
    var chartDefaults = {
        dateTimeLabelFormats: {
            millisecond: { main: millisecond },
            second: { main: second },
            minute: { main: minute },
            hour: { main: hour },
            day: { main: day },
            week: { main: week },
            month: { main: month },
            year: { main: year }
        },
        labels: { useHTML: true },
        title: { useHTML: true }
    };
    if (onSetExtremes) {
        chartDefaults.events = { afterSetExtremes: afterSetExtremes };
    }
    if (chartType === 'basic') {
        chartDefaults.tickLength = 0;
    }
    if (chartType === 'gantt') {
        chartDefaults.grid = { borderColor: '#FFFFFF00' };
    }
    if (xAxisElements && xAxisElements.length) {
        options = xAxisElements.map(function (xAxisElement) {
            var xAxisOptions = {};
            var _a = xAxisElement.props, children = _a.children, showGridLines = _a.showGridLines, labelPrefix = _a.labelPrefix, labelSuffix = _a.labelSuffix, overrides = __rest(_a, ["children", "showGridLines", "labelPrefix", "labelSuffix"]);
            var _b = utils_1.typeChildren(children), plotBands = _b.plotBands, plotLines = _b.plotLines;
            xAxisOptions = __assign({}, overrides);
            if (chartType === 'basic') {
                xAxisOptions.labels = __assign(__assign(__assign({}, chartDefaults.labels), { format: (labelPrefix || '') + "{value}" + (labelSuffix || '') }), xAxisOptions.labels);
            }
            if (plotBands) {
                xAxisOptions.plotBands = PlotBand_1.plotBandOptions(plotBands, colors);
            }
            if (plotLines) {
                xAxisOptions.plotLines = PlotLine_1.plotLineOptions(plotLines, colors);
            }
            if (typeof xAxisOptions.title === 'string') {
                xAxisOptions.title = __assign(__assign({}, chartDefaults.title), { text: xAxisOptions.title });
            }
            if (overrides.dateTimeLabelFormats) {
                var wrappedFormats_1 = {};
                Object.entries(overrides.dateTimeLabelFormats).forEach(function (_a) {
                    var key = _a[0], value = _a[1];
                    wrappedFormats_1[key] = { main: value };
                });
                xAxisOptions.dateTimeLabelFormats = __assign(__assign({}, chartDefaults.dateTimeLabelFormats), wrappedFormats_1);
            }
            if (showGridLines) {
                xAxisOptions.gridLineWidth = 1;
            }
            return __assign(__assign(__assign({}, chartDefaults), xAxisOptions), cleanedModifiers);
        });
    }
    else {
        options.push(__assign(__assign({}, chartDefaults), cleanedModifiers));
    }
    return options;
}
exports.default = default_1;
//# sourceMappingURL=xAxisOptions.js.map